var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('page-header',{attrs:{"header":_vm.$t('orders.title')}}),_c('div',{staticClass:"content"},[_c('admin-table',_vm._b({scopedSlots:_vm._u([{key:"amount",fn:function(ref){
var item = ref.item;
return [_c('order-final-amount',{attrs:{"order":item}})]}},{key:"status",fn:function(ref){
var item = ref.item;
return [_c('order-status',{staticClass:"mr-2",attrs:{"order":item}}),_c('value-payment-method',{attrs:{"item":item}})]}}])},'admin-table',_vm.tableProps,false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }